import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import BannerImg from '../../../../../public/assets/images/BannersFiles/31.jpg';
import { DataNotFound } from '../../../../components/DataNotFound';
import Loader from '../../../../components/Loader/Loader';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import PpCmsFilter from '../../../../components/elements/PpCmsFilter';
import StaticBanner from '../../../../components/elements/StaticBanner';
import { postAsync } from '../../../../components/helper/axiosHelper';
import { defaultImage, monthNames } from '../../../../constants';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../../shared/Helper';

export default function SuccessStory() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [datanotfound, setDatanotfound] = useState(false);
  const [sortOrder, setSortOrder] = useState(0);
  const [date, setDate] = useState('');
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 6,
  });
  const [searchTitle, setSearchTitle] = useState('');


  const { t } = useTranslation();
  const { pathname } = useLocation();


  const SearchFilter = {
    cmsTitle: searchTitle,
    dateFrom: moment(date).format('DD/MM/YYYY') ?? '',
    dateTo: moment(date).format('DD/MM/YYYY') || '',
  };


  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);


  const getData = async () => {
    setLoading(true);
    await postAsync(
      `CMSSuccessStory/GetUserSuccessStorySortFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
      SearchFilter,
    )
      .then((response) => {
        const result = response?.data;
        setApiData(result);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
        setLoading(false);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchData = async () => {
    const newPage = pageOptions.pageNo + 1;

    try {
      setPageOptions((prev) => {
        return {
          ...prev,
          pageNo: prev.pageNo + 1,
        };
      });
      const response = await postAsync(
        `CMSSuccessStory/GetUserSuccessStorySortFilterList/${newPage}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      const newData = response?.data || [];
      setApiData((prevData) => [...prevData, ...newData]);
      setCurrentPage(response.currentPage);
    } catch (error) {
      console.error('Error fetching data:', error);

      setHasMore(false);
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    getData();
  }, []);
  const onSearch = async () => {
    try {
      setLoading(true);
      setDatanotfound(false);
      setPageOptions((pre) => {
        return {
          ...pre,
          pageNo: 1,
        };
      });
      const response = await postAsync(
        `CMSSuccessStory/GetUserSuccessStorySortFilterList/${1}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      if (response) {
        setLoading(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className="">
        <StaticBanner BannerImg={BannerImg} en_US={'Success Story'} arabic={false} />
        <section className=" py-5 ">
          <div className="container justify-center ">
            <div className=''>
              <PpCmsFilter setSortOrder={ setSortOrder } date={ date } setDate={ setDate } getData={ onSearch } setSearchTitle={ setSearchTitle } />
            </div>
            <div className="row justify-center">
              { !loading && apiData?.length > 0 && (
                <InfiniteScroll
                  className="row justify-center"
                  dataLength={apiData?.length}
                  next={currentPage === pageCount ? <></> : fetchData}
                  hasMore={hasMore}
                  loader={
                    currentPage === pageCount ? (
                      <></>
                    ) : (
                      <div className="flex justify-center">
                        <Loader />
                      </div>
                    )
                  }
                >
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 grid-cols-1 grid-flow-row md:gap-14 gap-4 container">
                    {/*news box 1 */}
                    {apiData?.map((data, index) => {
                      // eslint-disable-next-line react/jsx-key
                      var dates = data?.date;
                      var parts = dates.split('/');
                      var formattedDateStr = parts[1] + '/' + parts[0] + '/' + parts[2];

                      var date = new Date(formattedDateStr);
                      var month = monthNames[date.getMonth()];
                      return (
                        // eslint-disable-next-line react/jsx-key
                        <Link
                          data-aos="zoom-in"
                          data-aos-once="true"
                          key={index}
                          to={`/SuccessStoryDetail/${data?.successStoryID}`}
                        >
                          <div className="h-80 hover:scale-105 transition-transform duration-300  max-w-sm bg-gray-100 my-2 rounded-3xl shadow-sm shadow-gray-200">
                            <div className="flex flex-col py-10 px-4  lg:pt-6 lg:py-10 lg:px-8">
                              <img
                                src={`data:image/jpeg;base64,${data?.doc ? data?.doc : defaultImage}`}
                                className="rounded-t-3xl h-40 w-full"
                              />
                              {/* <div className="w-20 h-20 mb-3 -mt-12 rounded-full shadow-md bg-customorange text-white  text-center font-semibold py-7">
                                {' '}
                                {t(month)}
                              </div> */}
                              <div className="h-20 w-20 mb-3 -mt-12 rounded-full shadow-md bg-customorange text-white text-center font-semibold flex flex-col items-center justify-center">
                                {/* Placeholder for month */}
                                <p className="leading-tight text-xl">
                                  {parts[0]}
                                  <br />
                                </p>
                                <p className="text-sm">{t(month)}</p>
                              </div>

                              {/* <h5 className="mb-1 font-semibold text-center w-full   text-customgreen lg:text-lg ">
                              {isActive ? data?.title : data?.titleEn}
                            </h5> */}
                              <h3 className="capitalize text-center w-full  text-customgreen lg:text-lg mb-1 font-semibold">
                                {isActive
                                  ? data?.title.length > 15
                                    ? `${data?.title.slice(0, 15)}...`
                                    : data?.title
                                  : data?.titleEn.length > 15
                                    ? `${data.titleEn.slice(0, 15)}...`
                                    : data.titleEn}
                              </h3>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </InfiniteScroll>
              )}
              {loading && <LoadingAnimation />}
            </div>
            {datanotfound && <DataNotFound />}
          </div>
        </section>
      </div>
    </>
  );
}
